import styled from "styled-components";

const RightDiv = styled.section`
    margin-left: 252px;
    padding: 5rem 4rem;
`

export { RightDiv }